<template>
  <div class="taskArchiving">
    <basiCcontainer>
      <commonTable tableHead="archiving" :config="{nothing}" ref="commonTable" :isSelfMak="true" :selection="false" :tipShow="false" :verifyRemark="$permission(['项目管理-激活项目','项目管理-删除项目'])">
        <template slot="verifyRemark" slot-scope="dataset">
          <span @click="handleCommand({task_id: dataset.data.id, command: 'activation'})" v-permission="'项目管理-激活项目'">激活任务</span>
          <span @click="handleCommand({task_id: dataset.data.id, command: 'delete'})" class="danger-style" v-permission="'项目管理-删除项目'">删除任务</span>
        </template>
      </commonTable>
    </basiCcontainer>
  </div>
</template>

<script>
import Bit from "@/components/bit"
import Common from "@/mixin/common.js";
import Pagination from "@/mixin/pagination.js";
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
export default {
  mixins: [Common, Pagination],
  components: {
    Bit
  },
  data() {
    return {
      taskList: [],
      project_id: null,
      ruleForm: {},
      nothing: {
        tip: '暂无归档任务',
        type: 'img_no_archive_task'
      }
    }
  },
  created() {
    this.project_id = this.$route.query.project_id || null;
    let { fullPath, path, query, name } = this.$route
    this.SET_MENUTXT({ fullPath, path, query, name, title: this.$route.meta.title, txt: this.$route.meta.title })
    this.fetchTaskList();
  },
  methods: {
    ...mapActions('task/task', ['getArchivedTaskList', 'activateTask', 'delTask', 'updateStatus']),
    fetchTaskList() {
      this.getArchivedTaskList({
        project_id: this.project_id,
        task_stage: '已归档',
        page: 1,
        number: 999
      }).then(res => {
        this.taskList = res.data
        this.$refs.commonTable.selfPageSplit(res.data)
      })
    },
    handleSizeChange() {
    },
    handleCurrentChange() {
    },
    async handleCommand(handleData) {
      console.log(handleData)
      if (handleData.command === "activation") {
        await this.$wfAlert('', '确认激活任务？')
        this.updateStatus({ task_id: handleData.task_id, task_stage: '进行中' }).then(res => {
          console.log(res)
          this.$message({
            type: 'success',
            message: '激活任务成功!'
          });
          this.fetchTaskList();
        })
      }
      if (handleData.command === "delete") {
        await this.$wfAlert('warning', '确认删除任务？')
        this.delTask({
          task_id: handleData.task_id
        }).then(res => {
          this.success("删除任务成功!");
          this.fetchTaskList();
        })
      }
    },
  }
}
</script>

<style lang="scss">
.archivi-task-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
